import styled, { css } from 'styled-components';

const BlockCardStyled = styled.li`
  ${() => {
    return css`
      border-width: 0.125em 0.125em 0.125em 0.375em;
      border-style: solid;
      border-color: var(--color-neutral-30);
      border-radius: 0.188em;
      background-color: var(--color-white);
      padding: 1.25em 1em 1em;
      position: relative;
      list-style: none;
      &:hover,
      &:focus-within {
        border-color: var(--color-teal);
      }
      &:focus,
      .block-card__btn:focus {
        border: none !important;
        box-shadow: none !important;
        outline: none;
      }
      .block-card__footer {
        margin-top: 1em;
      }
      .block-card__header,
      .block-card__footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .status-pill span:first-letter {
          text-transform: lowercase;
        }
      }
      .block-card__footer--wrap {
        flex-wrap: wrap;
        > div:first-child {
          margin-bottom: 0.5em;
        }
      }
      .block-card__title {
        font-weight: 700;
        font-size: 1em;
        line-height: 1.5em;
        margin: 0;
        color: var(--color-neutral-70);
      }
      .block-card__description {
        font-weight: 400;
        font-size: 0.875em;
        line-height: 1.5em;
        color: var(--color-neutral-70);
        margin: 1.25em 0 1em 0;
      }
      .block-card__btn {
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-decoration: none;
        width: 100%;
      }
      .block-card__btn:after {
        content: '';
        position: absolute;
        inset: 0;
      }
      .block-card__info {
        font-weight: 700;
        font-size: 0.875em;
        line-height: 1.5em;
        color: var(--color-neutral-60);
      }
    `;
  }}
`;

export default BlockCardStyled;
